import { FFAClubSupportWrapper } from "./wrappers"
import { lazy } from "react"
import { lazyRetry } from "./utils"
import { Route } from "react-router-dom"
import { AuthenticatedLayout } from "./wrappers"
import { SHOW_DEV_ONLY_COMPONENTS } from "@/const"

const ROUTE_PREFIX = "/ffa-club-support"

const FFAClubSupportDashboardOverview = lazy(() =>
	lazyRetry(() => import("../views/FFAClubSupport/FFAClubSupportDashboardOverview"), "ffaClubSupportPlayerAssign")
)
const FFAClubSupportDashboardClub = lazy(() =>
	lazyRetry(() => import("../views/FFAClubSupport/FFAClubSupportDashboardClub"), "ffaClubSupportPlayerAssign")
)
const ExerciseDashboard = lazy(() =>
	lazyRetry(() => import("../views/FFAClubSupport/ExerciseDashboard"), "ffaClubSupportPlayerAssign")
)
const FFAClubSupportPlayerAssign = lazy(() =>
	lazyRetry(() => import("../views/FFAClubSupport/FFAClubSupportPlayerAssign"), "ffaClubSupportPlayerAssign")
)
const FFAClubSupportRootGroupSettings = lazy(() =>
	lazyRetry(() => import("../views/FFAClubSupport/FFAClubSupportRootGroupSettings"), "ffaClubSupportRootGroupSettings")
)

const FFAClubSupportRoute = (
	<Route
		element={
			<FFAClubSupportWrapper>
				<AuthenticatedLayout fullWidth />
			</FFAClubSupportWrapper>
		}
	>
		<Route path={`${ROUTE_PREFIX}/player-assign`} element={<FFAClubSupportPlayerAssign />} />
		{SHOW_DEV_ONLY_COMPONENTS && (
			<Route path={`${ROUTE_PREFIX}/root-group-settings`} element={<FFAClubSupportRootGroupSettings />} />
		)}
		<Route path={`${ROUTE_PREFIX}/dashboard/overview`} element={<FFAClubSupportDashboardOverview />} />
		<Route path={`${ROUTE_PREFIX}/dashboard/:rootGroupId`} element={<FFAClubSupportDashboardClub />} />
		<Route path={`${ROUTE_PREFIX}/exerciseDashboard`} element={<ExerciseDashboard />} />
	</Route>
)

export default FFAClubSupportRoute
